import React from "react";
import { Typography } from "@material-ui/core";
export var MultilineHelperText = function (_a) {
    var texts = _a.texts;
    return (React.createElement(React.Fragment, null, texts.map(function (text) { return (React.createElement(Typography, { display: "block", variant: "caption", key: text }, text)); })));
};
